import React, { useState, useEffect, createContext, useContext } from 'react';
import WPApiFetch from '../Utility/WPApi'
//import queryString from 'query-string';
//import { useHistory, useLocation } from 'react-router-dom';
import {useAuth} from "./AuthContext"
export const QueryContext = createContext();

export default function QueryProvider({children}) {
	const [query, setQuery] = useState(null);
	const [response, setResponse] = useState(null);
	//const [total, setTotal] = useState(0);
	//const [totalPages, setTotalPages] = useState(0);
	const [loading, setLoading] = useState(false);

	//const history = useHistory();
	//const location = useLocation();
	const { nonce } = useAuth();

	useEffect(() => {
		const controller = new AbortController();
		async function fetchData() {
			setLoading(true);
			try {
				const data = await WPApiFetch(query, this, "GET", null, "include", nonce, controller.signal);
				setResponse(data);
			} catch(e) {
				if (e.name === "AbortError") return;
				console.log(e);
			}
			setLoading(false);
		}
		query && fetchData();
		return () => { controller.abort(); }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[query]);

	const value = { query, setQuery, response, setResponse, loading }
	return <QueryContext.Provider value={value}>{children}</QueryContext.Provider>
}

export function useQuery() {
	const context = useContext(QueryContext);
	if (context === undefined) {
		throw new Error("Context must be used within a Provider");
	}
	return context;
}